/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { MonitEntitySourcelistsResult } from './MonitEntitySourcelistsResult';
import {
    MonitEntitySourcelistsResultFromJSON,
    MonitEntitySourcelistsResultFromJSONTyped,
    MonitEntitySourcelistsResultToJSON,
} from './MonitEntitySourcelistsResult';

/**
 * 
 * @export
 * @interface MonitPaginatedEntitySourcelistsResponse
 */
export interface MonitPaginatedEntitySourcelistsResponse {
    /**
     * 
     * @type {number}
     * @memberof MonitPaginatedEntitySourcelistsResponse
     */
    page?: number;
    /**
     * 
     * @type {number}
     * @memberof MonitPaginatedEntitySourcelistsResponse
     */
    page_size?: number;
    /**
     * 
     * @type {number}
     * @memberof MonitPaginatedEntitySourcelistsResponse
     */
    count?: number;
    /**
     * 
     * @type {Array<MonitEntitySourcelistsResult>}
     * @memberof MonitPaginatedEntitySourcelistsResponse
     */
    results?: Array<MonitEntitySourcelistsResult>;
}

/**
 * Check if a given object implements the MonitPaginatedEntitySourcelistsResponse interface.
 */
export function instanceOfMonitPaginatedEntitySourcelistsResponse(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function MonitPaginatedEntitySourcelistsResponseFromJSON(json: any): MonitPaginatedEntitySourcelistsResponse {
    return MonitPaginatedEntitySourcelistsResponseFromJSONTyped(json, false);
}

export function MonitPaginatedEntitySourcelistsResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): MonitPaginatedEntitySourcelistsResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'page': !exists(json, 'page') ? undefined : json['page'],
        'page_size': !exists(json, 'page_size') ? undefined : json['page_size'],
        'count': !exists(json, 'count') ? undefined : json['count'],
        'results': !exists(json, 'results') ? undefined : ((json['results'] as Array<any>).map(MonitEntitySourcelistsResultFromJSON)),
    };
}

export function MonitPaginatedEntitySourcelistsResponseToJSON(value?: MonitPaginatedEntitySourcelistsResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'page': value.page,
        'page_size': value.page_size,
        'count': value.count,
        'results': value.results === undefined ? undefined : ((value.results as Array<any>).map(MonitEntitySourcelistsResultToJSON)),
    };
}

